import { isMobile, isMl3App, isiOS, isAndroid } from 'modules/DeviceOptions';

const activeKeys = [];

function gtag() {
  // seems like, cannot use arrow function
  window.dataLayer.push(arguments);
}

const pushGtagPageView = (options = {}) => {
  for (const id of activeKeys) {
    if (id) {
      gtag('config', id, options);
    }
  }
};

const init = () => {
  try {
    const { all, iosApp, androidApp, web } =
      (window.AS && window.AS.analyticsKeys) || {};

    activeKeys.push(all);

    if (isMobile && isMl3App) {
      if (isiOS) {
        activeKeys.push(iosApp);
      } else if (isAndroid) {
        activeKeys.push(androidApp);
      }
    } else {
      activeKeys.push(web);
    }
  } catch (e) {
    console.log(e);
  }

  //==default google tag code
  window.dataLayer = window.dataLayer || [];
  gtag('js', new Date());
  //=====================

  // push current page view
  pushGtagPageView();
};

init();

window.gtagObj = {
  pushGtagPageView
};
